/* eslint-disable max-len */
function PublishSvg2(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7305" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38017_7305)">
            <path d="M5.31532 10.7728C5.06864 10.643 4.58929 10.3906 3.87727 10.0157C3.41909 9.77444 3.24213 9.20536 3.48203 8.74461C3.56818 8.57913 3.70133 8.44316 3.86454 8.35398L13.5582 3.05722C13.7854 2.93307 14.0697 3.01765 14.1932 3.24614C14.2407 3.33399 14.2591 3.43475 14.2458 3.53384L12.9292 13.3559C12.8602 13.8713 12.3886 14.2328 11.8761 14.1633C11.7681 14.1487 11.6634 14.1152 11.5668 14.0644L9.95103 13.3559L7.85129 15.2543C7.65899 15.4281 7.36295 15.4123 7.19006 15.2189C7.11278 15.1325 7.07002 15.0204 7.07002 14.9041V12.4799L10.6722 7.85601" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>;
}

export default PublishSvg2;
